import React, { useState } from 'react';
import CartModal from '../../Components/CartModal';
import { useCart } from '../../Contexts/CartContext';
import BluelabProControllerWiFi from '../../Assets/Bluelab Pro Controller Wi-Fi.webp';
import 'bootstrap/dist/css/bootstrap.min.css'; // Import Bootstrap CSS

const Bluelab_Pro_Controller_WiFi = () => {
  const [showModal, setShowModal] = useState(false);
  const { addToCart } = useCart();

  const handleAddToCart = () => {
    const product = { id: 20, name: 'Bluelab Pro Controller Wi-Fi', price: 105840, image: BluelabProControllerWiFi };
    addToCart({ ...product, quantity: 1 });
    setShowModal(true);
  };

  return (
    <div className="container mt-3"> {/* Add margin top to the container */}
      <div className="row">
        <div className="col-md-6">
          <div id="productCarousel" className="carousel slide" data-ride="carousel">
            <div className="carousel-inner">
              <div className="carousel-item active">
                <img src={BluelabProControllerWiFi} alt="Product 1" className="d-block w-100" />
              </div>
              {/* Add more images to the carousel as needed */}
            </div>
            <a className="carousel-control-prev" href="#productCarousel" role="button" data-slide="prev">
              <span className="carousel-control-prev-icon" aria-hidden="true"></span>
              <span className="sr-only">Previous</span>
            </a>
            <a className="carousel-control-next" href="#productCarousel" role="button" data-slide="next">
              <span className="carousel-control-next-icon" aria-hidden="true"></span>
              <span className="sr-only">Next</span>
            </a>
          </div>
        </div>

        <div className="col-md-6">
          <div className="product-details">
            <h2 className="product-name">Bluelab Pro Controller Wi-Fi</h2>
            <p className="product-price">₹{105840}</p>
            <button className="btn btn-primary" onClick={handleAddToCart}>
              Add to Cart
            </button>
            <p className="product-description mt-3 text-justify">
             <h5>24/7 Remote Control of Reservoir pH, Conductivity, and Temperature from Your Phone</h5>
             <ul className='mt-2'>
              <li>Integrated Wi-Fi with an option to disable</li>
              <li>Monitor and automate nutrient and pH dosing when paired with Bluelab PeriPod dosers</li>
              <li>Easily access and control via mobile through Edenic.io</li>
              <li>Replaceable probes for pH (BNC connection), temperature, and conductivity</li>
              <li>Safety lockouts to prevent over-dosing</li>
              <li>Automatic resume of dosing after power outages</li>
              <li>Supports multi-part nutrient dosing with additional PeriPods</li>
              <li>Controls pH adjustment for both alkaline (up) and acid (down)</li>
              <li>Visual alarms for high/low parameter alerts</li>
              <li>Dosing routine ensures proper mixing before the next dose</li>
              <li>2-meter (6-foot) cable for optimal positioning and viewing</li>
             </ul>
            </p>
          </div>
        </div>
      </div>

      {/* Conditionally render the CartModal based on showModal */}
      {showModal && (
        <CartModal onClose={() => setShowModal(false)} />
      )}
    </div>
  );
};

export default Bluelab_Pro_Controller_WiFi;
